import { l } from '@manychat/manyui'

import { alert } from 'common/core'

export const SUCCESS_QUERY_PARAM = 'tiktokAdsSuccess'
export const ERROR_QUERY_PARAM = 'tiktokAdsError'

export enum TiktokAdsError {
  LACK_OF_PERMISSIONS = 'lack_of_permissions',
  COMMON_ERROR = 'common_error',
}

export const TiktokAdsErrors = [
  TiktokAdsError.LACK_OF_PERMISSIONS,
  TiktokAdsError.COMMON_ERROR,
] as const

export const TikTokErrorsAlerts: Record<TiktokAdsError, { alert: () => void }> = {
  [TiktokAdsError.LACK_OF_PERMISSIONS]: {
    alert: () => alert(l.translate('Not enough permissions. Try again'), 'danger'),
  },
  [TiktokAdsError.COMMON_ERROR]: {
    alert: () => alert(l.translate('Something went wrong'), 'danger'),
  },
} as const

export const CHANNELS_ORDER = ['tiktok', 'whatsapp', 'messenger'] as const
